<style lang="scss">
  .files-table {
    width: 100%;
    height: 100%;
  }
</style>

<script>
  import DataTable from "@sourcewhale/shared/svelte-design-system/components/molecules/DataTable/DataTable.svelte";
  import ActionsColumn from "./columns/ActionsColumn.svelte";
  import NoData from "./NoData.svelte";
  import { snippets } from "./Snippets.svelte";

  let { filesStore, deleteCallback } = $props();

  const { meta } = filesStore;
  const loading = $derived($meta?.fetching);

  const columns = [
    {
      name: "filename",
      title: "Name",
      data: "filename",
      orderable: false,
    },
    {
      name: "type",
      title: "Type",
      data: "filename",
      orderable: false,
    },
    {
      name: "size",
      title: "Size",
      data: "size",
      orderable: false,
    },
    {
      name: "uploaded",
      title: "Upload Date",
      data: "timestamp",
      orderable: false,
    },
    {
      name: "actions",
      title: "Actions",
      data: "",
      orderable: false,
    },
  ];
</script>

<div class="files-table">
  <DataTable
    {columns}
    data={$filesStore}
    skeleton={loading}
    fetching={loading}
    loadingMessage="Loading files..."
    {...snippets}
  >
    {#snippet actions(_, row)}
      <ActionsColumn {row} {deleteCallback} skeleton={loading} />
    {/snippet}

    {#snippet noData()}
      <NoData />
    {/snippet}
  </DataTable>
</div>
